// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5271":"77035675","7512":"77035675","8307":"0ca0924a","8689":"e2d96e67"}[chunkId] + ".chunk.css";
};